const getBaseApi = () => {
  switch (import.meta.env.MODE) {
    case 'LOCAL':
      return `http://localhost:3030/v1`;
    case 'STAGING':
      return `https://pwr-stage-api.aquafinance.com/v1`;
    case 'DEV':
      return `https://wfapi.dev-luna-aqua-middleware.com/v1`;
    case 'PRODUCTION':
      return `https://powerapi.aquafinance.com/v1`;
    default:
      return `https://wfapi.dev-luna-aqua-middleware.com/v1`;
  }
};

export default getBaseApi;
